module.exports = __webpack_public_path__ + "static/media/zaman-copyright-az.7b08ccfd.svg";